'use client';

import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Box, BoxProps, ListItemIcon, ListItemText } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { IconButton } from '../buttons';
import { useToggle } from '../../hooks';

export type MenuItem = {
    icon?: React.ReactElement<any>;
    text: string;
    onClick: () => void;
    disabled?: boolean;
    color?: string;
};

interface Props extends BoxProps {
    items: MenuItem[];
    iconColor?: string;
}

const IconMenu = ({ items, iconColor, ...boxProps }: Props) => {
    const [showMenu, toggleMenu] = useToggle();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const onButtonClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        toggleMenu();
        setAnchorEl(e.currentTarget);
    };

    const onCloseMenu = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        toggleMenu(false);
    };

    if (items.length !== 0) {
        return (
            <Box data-testid='icon-menu' {...boxProps}>
                <IconButton
                    data-testid='menu-button'
                    icon={<MoreVert style={{ color: iconColor }} />}
                    onClick={onButtonClick}
                />
                <Menu
                    data-testid='menu'
                    anchorEl={anchorEl}
                    open={showMenu}
                    onClose={onCloseMenu}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                >
                    {items.map(({ icon, text, onClick, disabled, color }, i) => (
                        <MenuItem
                            key={i}
                            disabled={disabled}
                            onClick={(e) => {
                                e.stopPropagation();
                                onClick();
                                onCloseMenu(e);
                            }}
                            sx={{ color }}
                        >
                            {icon && <ListItemIcon sx={{ color }}>{icon}</ListItemIcon>}
                            <ListItemText color={color}>{text}</ListItemText>
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
        );
    } else return <></>;
};

export { IconMenu };
